// extracted by mini-css-extract-plugin
export default {"darkContentSection":"lw91u___darkContentSection-module__darkContentSection"};